/* eslint-disable */
/*
 *
 *   Polylang Create Bootstrap Dropdown - WordPress
 *   Github: https://github.com/icetee/wp-bootstrap-polylang
 *
 *   I used (Fork):
 *   https://gist.github.com/icetee/5f44c321de44b13b903e
 *
 *   @since 1.2.4
 *
 */

(function wp_bootstrap_polylang($) {

    var $lang = $('html').attr('lang');
    var $navbar = $('#menu-top-navigatie');
    var $navitem = 'li.lang-item';
    var pageId = (typeof pllVars !== 'undefined' && pllVars.postID) ? pllVars.postID : '';

    console.log(pageId);
    var $changelang = "";
    var lang = {};

    if (!$navbar.find($navitem).hasClass("pll-lang")) {

        $lang = $lang.split('-')[0];

        $navbar.find($navitem).find('a').each(function() {
            var ltd = $(this).attr('hreflang').split('-')[0];
            lang[ltd] = $(this).attr('title');
        });

        if ($lang == 'nl') {
            $langval = 'Nederlands';
            $img = '<img src="/wp-content/uploads/2020/10/nl.jpg" class="lang-icon" title="Nederlands" alt="Nederlands" width="16" height="11" style="width: 16px; height: 11px;">';
        }
        if ($lang == 'en') {
            $langval = 'English';
            $img = '<img src="/wp-content/uploads/2020/10/en.png" class="lang-icon" title="English" alt="English" width="16" height="11" style="width: 16px; height: 11px;">';
        }
        if ($lang == 'de') {
            $langval = 'Deutsch';
            $img = '<img src="/wp-content/uploads/2020/10/de.jpg" class="lang-icon" title="Deutsch" alt="Deutsch" width="16" height="11" style="width: 16px; height: 11px;">';
        }

        $changelang += '<li class="menu-item lang-item menu-item-type-custom menu-item-object-custom menu-item-has-children dropdown pll-lang">';
        $changelang += '<a aria-haspopup="true" class="dropdown-toggle" data-toggle="dropdown" href="#" title="' + [$langval] + '">';
        $changelang +=  [$img] + [$langval];
        $changelang += ' <span class="caret"></span></a>';
        $changelang += '<ul class="dropdown-menu" role="menu">';

        $.each(lang, function(key, value) {
            if (key == 'nl') {
                $langval = 'Nederlands';
                $img = '<img src="/wp-content/uploads/2020/10/nl.jpg" class="lang-icon" title="Nederlands" alt="Nederlands" width="16" height="11" style="width: 16px; height: 11px;">';
            }
            if (key == 'en') {
                $langval = 'English';
                $img = '<img src="/wp-content/uploads/2020/10/en.png" class="lang-icon" title="English" alt="English" width="16" height="11" style="width: 16px; height: 11px;">';
            }
            if (key == 'de') {
                $langval = 'Deutsch';
                $img = '<img src="/wp-content/uploads/2020/10/de.jpg" class="lang-icon" title="Deutsch" alt="Deutsch" width="16" height="11" style="width: 16px; height: 11px;">';
            }
            $changelang += '<li class="lang-item ' + key + '"><a target="_self" href="//' + window.location.host + '/' + key + '/' + pageId[key] + '" title="'+ $langval + '">'+ $img + $langval + '</a></li>';
        });

        $changelang += '</ul></li>';

        $navbar.find($navitem).remove();
        if ($navbar.length) {
            $navbar.append($changelang);
        }
    }

})(jQuery);




// WEBPACK FOOTER //
// ./scripts/language.js